import React, { useContext } from "react";
import * as Handlebars from "handlebars";
import { useReceiptOrder } from "../ReceiptContext";
import * as R from "ramda";
import styled from "styled-components";
import { font } from "src/styles/themes";
import { MasterContext } from "../../../lib/masterContext";

export type TemplatedOrderTextProps = {
  className?: string;
  template: string;
};

export const TemplatedOrderText = (props: TemplatedOrderTextProps) => {
  const order = useReceiptOrder();
    const { flavor } = useContext(MasterContext);

  const { template, className } = props;
  if (!template) {
    return null;
  }

  Handlebars.registerHelper("sanitizeUrl", (url: string) => {
    return new Handlebars.SafeString(encodeURI(url))
  })
  

  const renderTemplate = Handlebars.compile(
    template.replaceAll(/(\r\n|\n)/g, "<br>")
  );

  const renderedHtml = renderTemplate({
    order: R.pick(
      [
        "id",
        "currencyCode",
        "customerId",
        "lineItems",
        "orderNumber",
        "processedAt",
        "createdAt",
        "draftCreatedAt",
        "status",
        "taxesIncluded",
        "totalTax",
        "totalPrice",
        "totalCRVTax",
        "taxBreakdown",
        "taxBreakdownTableData",
        "extraText",
        "paymentInfo",
        "fullyPaid",
        "subtotalPrice",
        "totalDiscounts",
      ],
      order
    ),
    store: order.store
      ? R.pick(
          [
            "id",
            "displayableName",
            "addressLine1",
            "addressCity",
            "addressRegion",
            "addressCountry",
            "addressPostalCode",
          ],
          order.store
        )
      : {},
    flavor: {
      mainColor: flavor.getMainColor(),
      iconColor: flavor.getIconColor(),
      spinnerColor: flavor.getSpinnerColor(),
      dashLineColor: flavor.getDashLineColor(),
    }
  });

  return (
    <Templated
      className={className}
      dangerouslySetInnerHTML={{ __html: renderedHtml }}
    />
  );
};

export const Templated = styled.div`
  font-family: ${font.family.fromVariable};
  font-size: ${font.size.subtitleText}px;
  font-weight: 500;
  color: #000000;
  padding: 0 8px;
  line-height: 1.1em;
`;
